// Helper function removes things like dollar signs, commas, and whitespace from strings representing dollars
export const removeNonIntegers = (str) => str.replace(/[^0-9]/g, '');